export {
	buildFrontendRecommendationOptions,
	type FrontendQuickStudySession,
} from "./adapters/frontend-option-adapter";
export { buildRecommendationFrontendContext } from "./adapters/frontend-context";
export {
	combineDurationRecommendationResults,
	resolveQuickStudyRecommendationSessions,
} from "./application/resolve-recommendation-source";
